module.exports = __webpack_public_path__ + "static/media/radiant-sweet.56aa594a.png";